;(function( $, window, document, undefined ) {

	/**
	 *  Add background to parent element image
	 */

	function wpc_add_img_bg( img_sel, parent_sel ) {

		if ( !img_sel ) {
			console.info( 'no img selector' );
			return false;
		}

		var $parent, _this;

		$( img_sel ).each( function() {
			_this = $( this );
			$parent = _this.closest( parent_sel );
			$parent = $parent.length ? $parent : _this.parent();
			$parent.css( 'background-image', 'url(' + this.src + ')' );
			_this.hide();
		} );

	}

	wpc_add_img_bg( '.js-bg-img' );

	/**
	 * Hamburger menu
	 */
	var headerIcon = $( '.js-header-icon' );

	$( headerIcon ).on( 'click', function() {
		let menuList = $( '#menu-header-menu' );
		$( '.de-header' ).toggleClass( 'activeMobile' );
		$( this ).toggleClass( 'active' );
		$( 'html' ).toggleClass( 'activeMobile' );
		if ( $( '.de-header' ).hasClass( 'activeMobile' ) ) {
			$( '<ul class="mobile-menu-additional-content"><li class="footer__list--link"><a href="https://www.isda.org/membership/">Join ISDA</a></li><li class="footer__list--link"><a href="https://www.isda.org/media-contacts/">Media Contacts</a></li><li class="footer__list--link"><a href="https://www.isda.org/general/terms-and-conditions/">Terms and Conditions</a></li></ul>' )
				.insertAfter( menuList );
			let mobileLogoLink = $( this ).find( '.de-header__mobile-logo' );
			mobileLogoLink.find( 'img' )
			              .attr( 'src', '../../wp-content/themes/isda/assets/images/logo-dark.png' );
			$( '.menu-item' ).find( 'a[href$="#contact-us"]' )
			                 .on( 'click', function() {
				                 $( '.de-header' )
					                 .removeClass( 'activeMobile' );
				                 $( '.js-header-icon' ).removeClass( 'active' );
				                 $( 'html' ).removeClass( 'activeMobile' );
				                 $( '.mobile-menu-additional-content' )
					                 .remove();
			                 } );
		} else {
			$( '.mobile-menu-additional-content' ).remove();
		}
		let mobileLogoLink = $( this ).find( '.de-header__mobile-logo' );
		mobileLogoLink.find( 'img' )
		              .attr( 'src', '../../wp-content/themes/isda/assets/images/logo-dark.png' );
	} );

	/**
	 * Header navigation menu active page and disabled logo link on home page
	 */
	let location = window.location.origin + window.location.pathname;
	$( '.de-header__menu-list li' ).each( function() {
		var link = $( this ).find( 'a' ).attr( 'href' );

		if ( location == link ) {
			$( this ).addClass( 'current' );
		}

	} );

	if ( $( 'body' ).hasClass( 'home' ) ) {
		$( '.de-header__desktop-logo' ).attr( 'disabled', 'disabled' );
	}

	if ( !($( '#contact-us' ).length
	) ) {
		$( 'a[href="#contact-us"]' ).on( 'click', function() {
			let url = '/#contact-us';
			window.location.href = window.location.origin + url;
		} );
	}

	if ( $( window ).width() <= 1025 ) {
		$( '.js-header-singUp a' ).html( ' Let’s sign up' );
		$( '.js-header-singUp' )
			.append( '<span>Don’t have account yet?</span>' );
	}

	/**
	 * Pop-up functionality
	 */
	$( window ).load( function() {
		if ( $( '.pop-up-close' ).length ) {
			$( 'html' ).css( 'overflow', 'hidden' );
		}
	} );
	$( '.pop-up-close' ).click( function() {
		$( '.pop-up-overlay' ).fadeOut();
		$( 'html' ).css( 'overflow', 'auto' );
	} );
	/**
	 * Fixed menu
	 */
	let headerMenu = $( '.de-header' );
	let scrollPos = 0;
	$( window ).scroll( function() {
		if ( $( this ).scrollTop() > $( headerMenu ).height() ) {
			let st = $( this ).scrollTop();
			if ( st > scrollPos ) {
				headerMenu.removeClass( 'fixed' );
			} else {
				headerMenu.addClass( 'fixed' );
			}
			scrollPos = st;
		} else {
			headerMenu.removeClass( 'fixed' );
		}
	} );

	/**
	 * Read More/Less Btn functionality
	 */

	$( '.mp-types__read-more-wr' ).on( 'click', function() {
		$( this ).closest( '.mp-types__s-item' ).toggleClass( 'showMore' );
		let replaceText = $( this ).closest( '.mp-types__s-item' )
		                           .hasClass( 'showMore' )
		                  ? 'Read Less'
		                  : 'Read More';
		let changeIcon = $( this ).closest( '.mp-types__s-item' )
		                          .hasClass( 'showMore' )
		                 ? 'rotate(45deg)'
		                 : 'rotate(0deg)';
		$( this ).find( '.read-more-text' ).text( replaceText );
		$( this ).find( '.read-more-icon' ).css( 'transform', changeIcon );
	} );

	/**
	 * Read More/Less Btn function for banner Main page
	 */
	function addReadMoreForBanner() {
		var bannerDescription = $( '.mp-banner__desc' );

		$( '.mp-banner__desc' ).addClass( 'mp-banner__desc--hide' );
		$( '.mp-banner__read-more-wr' ).css( 'display', 'block' );
	}

	$( window ).on( 'resize', function() {
		if ( $( window ).width() <= 768 ) {
			addReadMoreForBanner();
		}

		if ( $( window ).width() >= 769 ) {
			$( '.mp-banner__read-more-wr' ).hide();
			$( '.mp-banner__desc' ).removeClass( 'mp-banner__desc--hide' );
		}
	} );

	$( '.mp-banner__read-more-wr' ).on( 'click', function() {
		$( '.mp-banner__desc' ).toggleClass( 'mp-banner__desc--show' );
		let replaceText = $( '.mp-banner__desc' )
			                  .hasClass( 'mp-banner__desc--show' )
		                  ? 'Read Less'
		                  : 'Read More';
		let changeIcon = $( '.mp-banner__desc' )
			                 .hasClass( 'mp-banner__desc--show' )
		                 ? 'rotate(45deg)'
		                 : 'rotate(0deg)';
		$( this ).find( '.read-more-text' ).text( replaceText );
		$( this ).find( '.read-more-icon' ).css( 'transform', changeIcon );
	} );

	if ( $( window ).width() <= 768 ) {
		addReadMoreForBanner();
	}

	$( '.membership-banner__read-more-wr' ).on( 'click', function() {
		$( this ).siblings( '.membership-banner__content-desc' )
		         .toggleClass( 'showMore' );

		let replaceText = $( this )
			                  .siblings( '.membership-banner__content-desc' )
			                  .hasClass( 'showMore' )
		                  ? 'Read Less'
		                  : 'Read More';
		let changeIcon = $( this )
			                 .siblings( '.membership-banner__content-desc' )
			                 .hasClass( 'showMore' )
		                 ? 'rotate(45deg)'
		                 : 'rotate(0deg)';

		$( this ).find( '.read-more-text' ).text( replaceText );
		$( this ).find( '.read-more-icon' ).css( 'transform', changeIcon );
	} );

	/**
	 * Change main page Banner background image
	 */
	var imgArr =  [
		'/wp-content/themes/isda/assets/images/main-banner-image-2-compressed.jpg',
		'/wp-content/themes/isda/assets/images/main-banner-image-2-compressed.jpg',
		'/wp-content/themes/isda/assets/images/main-banner-image-3-compressed.jpg',
		'/wp-content/themes/isda/assets/images/main-banner-image-4-compressed.jpg',
		'/wp-content/themes/isda/assets/images/main-banner-image-5-compressed.jpg',
		'/wp-content/themes/isda/assets/images/main-banner-image-compressed.jpg'
	], i       = 1;

	setInterval( function() {
		//if this is NOT mobile
		if ( $( window ).width() > 768 ) {
			if ( i > (imgArr.length - 1
			) ) {
				$( '.mp-banner' ).animate( 1000, function() { //{'opacity':'0'},
					i = 1;
					$( '.mp-banner' ).css( {
						                       'background-image': 'url(' + imgArr[ 0 ] + ');',
						                       'transition'      : '.9s background-image linear'
					                       } );
				} );
				$( '.mp-banner' ).animate( 1000 ); //{'opacity':'1'},
			} else {
				$( '.mp-banner' ).animate( 1000, function() { //{'opacity':'0'},
					$( '.mp-banner' ).css( {
						                       'background-image': 'url(' + imgArr[ i ] + ')',
						                       'transition'      : '.9s background-image linear'
					                       } );
					i++;
				} );
				$( '.mp-banner' ).animate( 1000 ); //{'opacity':'1'},
			}
		}

	}, 8000 );

	/**
	 * Card flipping
	 */
	let moreBtn = $( '.flip-card-btn' );
	$( moreBtn ).click( function() {
		$( this ).closest( '.item' ).toggleClass( 'is-flipped' );

		if ( $( window ).width() < 577 ) { //Height calculating
			let itemBackHeight = $( this ).closest( '.item' )
			                              .find( '.item-back__wr' ).height();

			if ( $( this ).closest( '.item' ).hasClass( 'is-flipped' ) ) {
				$( this ).closest( '.is-flipped' )
				         .height( itemBackHeight + 60 );
				let newItemHeight = itemBackHeight + 60;
				$( this ).closest( '.item' ).height( newItemHeight );
			} else {
				$( this ).closest( '.row' ).height( 'auto' );
				$( this ).closest( '.item' ).height( '300px' );
			}
		}
	} );

	/**
	 * Accordion
	 */
	$( '.list-item__btn' ).on( 'click', function() {
		$( this ).closest( '.list-item' ).toggleClass( 'list-item--show' );
	} );

	$( '.list-item__title' ).on( 'click', function() {
		$( this ).closest( '.list-item' ).toggleClass( 'list-item--show' );
	} );

	/**
	 * Expand all benefits
	 */
	let isExpandAll = true;

	$( '.sp-benefits__show-all' ).on( 'click', function() {
		isExpandAll = !isExpandAll;

		if ( !isExpandAll ) {
			$( '.sp-benefits__list-item' ).addClass( 'list-item--show' );
			$( this ).find( '.show-all__text' ).text( 'Close All' );
			$( this ).find( '.btn-circle' ).css( 'transform', 'rotate(45deg)' );
		}
		if ( isExpandAll ) {
			$( this ).find( '.show-all__text' ).text( 'Expand All' );
			$( '.sp-benefits__list-item' ).removeClass( 'list-item--show' );
			$( this ).find( '.btn-circle' ).css( 'transform', 'rotate(0deg)' );
		}
	} );

	/**
	 * Cookies section
	 */

	// $('#cookieBtnId').on('click', function () {
	// 	localStorage.setItem('isAccept', 'true');
	//
	// 	if(localStorage.getItem('isAccept') === 'true') {
	// 		$('.cookie').css('display', 'none');
	// 	}
	// });
	//
	// if(localStorage.getItem('isAccept') === 'false') {
	// 	$('.cookie').addClass('active');
	// }
	//
	// if(localStorage.getItem('isAccept') === 'true') {
	// 	$('.cookie').css('display', 'none');
	// }

}
)( jQuery, window, document );
